/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24/ContainerHome24';
import CustomEmblaCarouselHome24 from '../../organisms/CustomEmblaCarouselHome24';
import Styles from './Home24Carouselv2.css';
import { isMobile } from '@/utils/browser';
import clsx from 'clsx';

function Home24Carouselv2() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <section id="santander-carousel">
      <ContainerHome24>
        <div className="santander-carousel-contain">
          <CustomEmblaCarouselHome24
            loop
            enableBullets
            enableMobileArrows
            detectBulletCount
            hideOverflow
            autoplay={8}
          >
            {({ className }) => (
              <>
                <div className={`slide ${className}`}>
                  <a href="energia-solar-fotovoltaica.html" alt="">
                    <div className="bg-banner">
                      {typeof window === 'undefined' ? (
                        <></>
                      ) : (
                        <>
                          {width <= 312 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/solar/banner-312.png"
                              />
                              <img
                                src="assets/home24/banners-v2/solar/banner-312.png"
                                alt="Homem jovem de camisa social laranja usando o celular em um campo com painéis solares ao fundo. O texto incentiva o financiamento do sistema com o Santander para reduzir custos de energia em casa ou na empresa."
                                className=""
                              />
                            </picture>
                          )}
                          {width > 312 && width <= 460 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/solar/banner-414.png"
                              />
                              <img
                                src="assets/home24/banners-v2/solar/banner-414.png"
                                alt="Homem jovem de camisa social laranja usando o celular em um campo com painéis solares ao fundo. O texto incentiva o financiamento do sistema com o Santander para reduzir custos de energia em casa ou na empresa."
                                className=""
                              />
                            </picture>
                          )}
                          {width > 460 && width <= 600 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/solar/banner-601.png"
                              />
                              <img
                                src="assets/home24/banners-v2/solar/banner-601.png"
                                alt="Homem jovem de camisa social laranja usando o celular em um campo com painéis solares ao fundo. O texto incentiva o financiamento do sistema com o Santander para reduzir custos de energia em casa ou na empresa."
                                className=""
                              />
                            </picture>
                          )}
                          {width > 600 && width <= 800 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/solar/banner-800.png"
                              />
                              <img
                                src="assets/home24/banners-v2/solar/banner-800.png"
                                alt="Homem jovem de camisa social laranja usando o celular em um campo com painéis solares ao fundo. O texto incentiva o financiamento do sistema com o Santander para reduzir custos de energia em casa ou na empresa."
                                className=""
                              />
                            </picture>
                          )}
                          {width > 800 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/solar/banner-1280.png"
                              />
                              <img
                                src="assets/home24/banners-v2/solar/banner-1280.png"
                                alt="Homem jovem de camisa social laranja usando o celular em um campo com painéis solares ao fundo. O texto incentiva o financiamento do sistema com o Santander para reduzir custos de energia em casa ou na empresa."
                                className=""
                              />
                            </picture>
                          )}
                        </>
                      )}
                    </div>
                    <div className="conteudo-banner">
                      <p className="banner-saber-mais">Saiba mais</p>
                    </div>
                  </a>
                </div>
                <div className={`slide ${className}`}>
                  <a href="emprestimo-garantia-carro.html" alt="">
                    <div className="bg-banner">
                      {typeof window === 'undefined' ? (
                        <></>
                      ) : (
                        <>
                          {width <= 312 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/cp-com-garantia/banner-312.png"
                              />
                              <img
                                src="assets/home24/banners-v2/cp-com-garantia/banner-312.png"
                                alt="Homem jovem encostado em um carro vermelho enquanto mexe no celular. O texto destaca a possibilidade de crédito de até R$ 200 mil usando o veículo como garantia na Santander Financiamentos."
                                className=""
                              />
                            </picture>
                          )}
                          {width > 312 && width <= 460 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/cp-com-garantia/banner-414.png"
                              />
                              <img
                                src="assets/home24/banners-v2/cp-com-garantia/banner-414.png"
                                alt="Homem jovem encostado em um carro vermelho enquanto mexe no celular. O texto destaca a possibilidade de crédito de até R$ 200 mil usando o veículo como garantia na Santander Financiamentos."
                                className=""
                              />
                            </picture>
                          )}
                          {width > 460 && width <= 600 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/cp-com-garantia/banner-601.png"
                              />
                              <img
                                src="assets/home24/banners-v2/cp-com-garantia/banner-601.png"
                                alt="Homem jovem encostado em um carro vermelho enquanto mexe no celular. O texto destaca a possibilidade de crédito de até R$ 200 mil usando o veículo como garantia na Santander Financiamentos."
                                className=""
                              />
                            </picture>
                          )}
                          {width > 600 && width <= 800 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/cp-com-garantia/banner-800.png"
                              />
                              <img
                                src="assets/home24/banners-v2/cp-com-garantia/banner-800.png"
                                alt="Homem jovem encostado em um carro vermelho enquanto mexe no celular. O texto destaca a possibilidade de crédito de até R$ 200 mil usando o veículo como garantia na Santander Financiamentos."
                                className=""
                              />
                            </picture>
                          )}
                          {width > 800 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/cp-com-garantia/banner-1280.png"
                              />
                              <img
                                src="assets/home24/banners-v2/cp-com-garantia/banner-1280.png"
                                alt="Homem jovem encostado em um carro vermelho enquanto mexe no celular. O texto destaca a possibilidade de crédito de até R$ 200 mil usando o veículo como garantia na Santander Financiamentos."
                                className=""
                              />
                            </picture>
                          )}
                        </>
                      )}
                    </div>
                    <div className="conteudo-banner">
                      <p className="banner-saber-mais">Simule agora</p>
                    </div>
                  </a>
                </div>
                <div className={`slide ${className}`}>
                  <a href="renegociacao-santander-financiamentos.html" alt="">
                    <div className="bg-banner">
                      {typeof window === 'undefined' ? (
                        <></>
                      ) : (
                        <>
                          {width <= 312 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/reneg/banner-312.png"
                              />
                              <img
                                src="assets/home24/banners-v2/reneg/banner-312.png"
                                alt="Mulher jovem de camiseta azul e shorts claros, relaxada em um sofá enquanto mexe no smartphone. O texto destaca a facilidade de negociar dívidas com parceiros para resolver pendências financeiras com o Santander"
                                className=""
                              />
                            </picture>
                          )}
                          {width > 312 && width <= 460 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/reneg/banner-414.png"
                              />
                              <img
                                src="assets/home24/banners-v2/reneg/banner-414.png"
                                alt="Mulher jovem de camiseta azul e shorts claros, relaxada em um sofá enquanto mexe no smartphone. O texto destaca a facilidade de negociar dívidas com parceiros para resolver pendências financeiras com o Santander"
                                className=""
                              />
                            </picture>
                          )}
                          {width > 460 && width <= 600 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/reneg/banner-601.png"
                              />
                              <img
                                src="assets/home24/banners-v2/reneg/banner-601.png"
                                alt="Mulher jovem de camiseta azul e shorts claros, relaxada em um sofá enquanto mexe no smartphone. O texto destaca a facilidade de negociar dívidas com parceiros para resolver pendências financeiras com o Santander"
                                className=""
                              />
                            </picture>
                          )}
                          {width > 600 && width <= 800 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/reneg/banner-800.png"
                              />
                              <img
                                src="assets/home24/banners-v2/reneg/banner-800.png"
                                alt="Mulher jovem de camiseta azul e shorts claros, relaxada em um sofá enquanto mexe no smartphone. O texto destaca a facilidade de negociar dívidas com parceiros para resolver pendências financeiras com o Santander"
                                className=""
                              />
                            </picture>
                          )}
                          {width > 800 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/reneg/banner-1280.png"
                              />
                              <img
                                src="assets/home24/banners-v2/reneg/banner-1280.png"
                                alt="Mulher jovem de camiseta azul e shorts claros, relaxada em um sofá enquanto mexe no smartphone. O texto destaca a facilidade de negociar dívidas com parceiros para resolver pendências financeiras com o Santander"
                                className=""
                              />
                            </picture>
                          )}
                        </>
                      )}
                    </div>
                    <div className="conteudo-banner">
                      <p className="banner-saber-mais">Renegociar</p>
                    </div>
                  </a>
                </div>
                <div className={`slide ${className}`}>
                  <a href="parcelamento-bens-servicos.html" alt="">
                    <div className="bg-banner">
                      {typeof window === 'undefined' ? (
                        <></>
                      ) : (
                        <>
                          {width <= 312 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/bens/banner-312.png"
                              />
                              <img
                                src="assets/home24/banners-v2/bens/banner-312.png"
                                alt="Banner com uma mulher sorridente lendo um catálogo de móveis. O banner oferece facilidades de parcelamento para bens e serviços através de parceiros com o Santander."
                                className=""
                              />
                            </picture>
                          )}
                          {width > 312 && width <= 460 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/bens/banner-414.png"
                              />
                              <img
                                src="assets/home24/banners-v2/bens/banner-414.png"
                                alt="Banner com uma mulher sorridente lendo um catálogo de móveis. O banner oferece facilidades de parcelamento para bens e serviços através de parceiros com o Santander."
                                className=""
                              />
                            </picture>
                          )}
                          {width > 460 && width <= 600 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/bens/banner-601.png"
                              />
                              <img
                                src="assets/home24/banners-v2/bens/banner-601.png"
                                alt="Banner com uma mulher sorridente lendo um catálogo de móveis. O banner oferece facilidades de parcelamento para bens e serviços através de parceiros com o Santander."
                                className=""
                              />
                            </picture>
                          )}
                          {width > 600 && width <= 800 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/bens/banner-800.png"
                              />
                              <img
                                src="assets/home24/banners-v2/bens/banner-800.png"
                                alt="Banner com uma mulher sorridente lendo um catálogo de móveis. O banner oferece facilidades de parcelamento para bens e serviços através de parceiros com o Santander."
                                className=""
                              />
                            </picture>
                          )}
                          {width > 800 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/bens/banner-1280.png"
                              />
                              <img
                                src="assets/home24/banners-v2/bens/banner-1280.png"
                                alt="Banner com uma mulher sorridente lendo um catálogo de móveis. O banner oferece facilidades de parcelamento para bens e serviços através de parceiros com o Santander."
                                className=""
                              />
                            </picture>
                          )}
                        </>
                      )}
                    </div>
                    <div className="conteudo-banner">
                      <p className="banner-saber-mais">Saiba mais</p>
                    </div>
                  </a>
                </div>
                <div className={`slide ${className}`}>
                  <a
                    href="https://tagsantander.semparar.com.br/#/?utm_source=santander-financiamentos&utm_medium=pagina-home-carrossel-sem-parar"
                    alt=""
                    target="_blank"
                  >
                    <div className="bg-banner">
                      {typeof window === 'undefined' ? (
                        <></>
                      ) : (
                        <>
                          {width <= 312 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/sem-parar/banner-312.png"
                              />
                              <img
                                src="assets/home24/banners-v2/sem-parar/banner-312.png"
                                alt="Mulher dirigindo com expressão de tranquilidade e usando fones de ouvido sem fio. À esquerda, texto sobre ganhar agilidade e praticidade na rotina com a Tag Santander Sem Parar."
                                className=""
                              />
                            </picture>
                          )}
                          {width > 312 && width <= 460 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/sem-parar/banner-414.png"
                              />
                              <img
                                src="assets/home24/banners-v2/sem-parar/banner-414.png"
                                alt="Mulher dirigindo com expressão de tranquilidade e usando fones de ouvido sem fio. À esquerda, texto sobre ganhar agilidade e praticidade na rotina com a Tag Santander Sem Parar."
                                className=""
                              />
                            </picture>
                          )}
                          {width > 460 && width <= 600 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/sem-parar/banner-601.png"
                              />
                              <img
                                src="assets/home24/banners-v2/sem-parar/banner-601.png"
                                alt="Mulher dirigindo com expressão de tranquilidade e usando fones de ouvido sem fio. À esquerda, texto sobre ganhar agilidade e praticidade na rotina com a Tag Santander Sem Parar."
                                className=""
                              />
                            </picture>
                          )}
                          {width > 600 && width <= 800 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/sem-parar/banner-800.png"
                              />
                              <img
                                src="assets/home24/banners-v2/sem-parar/banner-800.png"
                                alt="Mulher dirigindo com expressão de tranquilidade e usando fones de ouvido sem fio. À esquerda, texto sobre ganhar agilidade e praticidade na rotina com a Tag Santander Sem Parar."
                                className=""
                              />
                            </picture>
                          )}
                          {width > 800 && (
                            <picture>
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners-v2/sem-parar/banner-1280.png"
                              />
                              <img
                                src="assets/home24/banners-v2/sem-parar/banner-1280.png"
                                alt="Mulher dirigindo com expressão de tranquilidade e usando fones de ouvido sem fio. À esquerda, texto sobre ganhar agilidade e praticidade na rotina com a Tag Santander Sem Parar."
                                className=""
                              />
                            </picture>
                          )}
                        </>
                      )}
                    </div>
                    <div className="conteudo-banner">
                      <p className={clsx('banner-saber-mais', 'banner-saber-mais-sem-parar')}>
                        Conheça
                      </p>
                    </div>
                  </a>
                </div>
              </>
            )}
          </CustomEmblaCarouselHome24>
        </div>
      </ContainerHome24>

      <style jsx>{Styles}</style>
    </section>
  );
}

export default Home24Carouselv2;
